import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { JobTitle } from '../models/job-title.model';

@Injectable()
export class JobTitleService {
    readonly apiServer: string;

    constructor(private _configService: ConfigService, private _http: HttpClient) { 
        this.apiServer = this._configService.appSettings.webApiServer  + "api/JobTitle/";
    }

    async getJobTitleByAbbreviation(abbreviation: string): Promise<JobTitle> {
        const params = new HttpParams()
            .set('Abbreviation', abbreviation);

        return await this._http.get<JobTitle>(`${this.apiServer}GetJobTitleByAbbreviation`, { params: params}).toPromise<JobTitle>();
    }

    async getJobTitleById(id: number) : Promise<JobTitle> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.get<JobTitle>(`${this.apiServer}GetJobTitleById`, { params: params }).toPromise<JobTitle>();
    }

    async getJobTitles() {
        return await this._http.get<JobTitle[]>(`${this.apiServer}GetJobTitles`).toPromise<JobTitle[]>();
    }
    
    async getJobTitlesInfiniteScroll(mostRecent: boolean, offset: number, totalItems: number, searchText: string, orderBy: string, direction: string): Promise<JobTitle[]> {
        const params = new HttpParams()
            .set('mostRecent', mostRecent.toString())
            .set('offset', offset.toString())
            .set('totalItems', totalItems.toString())
            .set('searchText', searchText)
            .set('orderBy', orderBy)
            .set('direction', direction);

        return await this._http.get<JobTitle[]>(`${this.apiServer}GetJobTitlesInfiniteScroll`, { params: params }).toPromise<JobTitle[]>();
    }

    async removeJobTitle(id: number): Promise<number> {
        const params = new HttpParams()
            .set('Id', id.toString());

        return await this._http.delete<number>(`${this.apiServer}RemoveJobTitle`, { params: params }).toPromise<number>();
    }
  async getCostCentersByJobTitleId(id: number): Promise<string[]> {
        const params = new HttpParams()
            .set('Id', id.toString());
            return await this._http.get<string[]>(`${this.apiServer}GetCostCentersByJobTitleId`, { params: params }).toPromise<string[]>();
    }

    async setJobTitle(jobTitle: JobTitle): Promise<JobTitle> {            
        return await this._http.post<JobTitle>(`${this.apiServer}SetJobTitle`, JSON.stringify(jobTitle)).toPromise<JobTitle>();
    }
}
